module.exports = __webpack_public_path__ + "static/img/zhongzhongka23.bcc7245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka23.png
// module id = cw59
// module chunks = 16